import { Field, Form as FormikForm, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Button,
    Form, Grid, Header, Label, Modal, Table
} from "semantic-ui-react";
import {
    FormikDateComponent,
    FormikInputComponent,
    FormikIntegerComponent
} from "../../../utilities/formUtils";
import { heightSet, rowBodyHeightSet } from "../../../utilities/heightSet";
import { fetchMaruti, repost, setNotifyDone, syncUtd } from "../data/actions";
import * as select from "../data/selectors";

import { toast } from "react-toastify";
import {
    missingUtd,
    missingUtdSchema,
    searchColumns
} from "../data/model";
import SyncOptions from "./syncOption";
import { TableListDiv } from "./tableListDiv";


let count = 0;
// const Maruti = props => {
//     let rlb_payload = ''
//     let rlbid = ''
//     if (props.maruti.status === "exception")
//         rlbid = props.maruti.rlb_payload
//     else {
//         rlb_payload = JSON.parse(props.maruti.rlb_payload)
//         if (props.maruti.status === "success")
//             rlbid = null
//         if (props.maruti.status === "error")
//             rlbid = rlb_payload.msg
//     }

//     const dispatch = useDispatch();
//     const reposting = (redisId) => {
//         dispatch(repost(redisId))
//     }

//     const showDetails = () => {
//             let obj =props.maruti.rlb_payload
//             alert('redisId : '+ props.maruti.redisId +"\r\n"+ obj)
//     }

//     return (
//         <Table.Row>
//             <Table.Cell>{props.maruti.trans_date}</Table.Cell>
//             <Table.Cell>{props.maruti.txntype}</Table.Cell>
//             <Table.Cell>{props.maruti.trans_id}</Table.Cell>
//             <Table.Cell>{props.maruti.trans_ref_num}</Table.Cell>
//             <Table.Cell>{props.maruti.mul_dealer_cd}</Table.Cell>
//             <Table.Cell>{rlbid == null ? '' : rlbid}</Table.Cell>

//             {
//                 props.maruti.status === 'error' || props.maruti.status === 'exception' ?
//                 <Table.Cell >
//                     <span style={{textTransform:'capitalize', color:'red', cursor:'pointer'}} onClick={() => showDetails(props.maruti.redisId)}>{props.maruti.status}</span>
//                     &nbsp;&nbsp;&nbsp;&nbsp;
//                      {
//                         props.maruti["postStatus"] === undefined
//                         ?<span style={{color:'blue', cursor:'pointer'}}  onClick={() => reposting(props.maruti.redisId)} >Repost</span>
//                         :<span style={{color:'green'}}>Reposted</span>
//                      }
//                 </Table.Cell>
//                 :<Table.Cell style={{color:'green', textTransform:'capitalize'}}>
//                     {props.maruti.status}
//                 </Table.Cell>
//             }
//         </Table.Row>
// )}

// const MarutiList = (props) => {
//     const maruti = useSelector(state => select.getFilteredMarutiList(state))
//     //const filteredMarutiList = useSelector(state => state.txnsync.collection)
//     const marutiById = useSelector(state => state.txnsync.byId)
//     const marutiFetched = useSelector(state => select.getIsMarutiFetched(state, props))
//     const summary = useSelector(state => select.getSummary(state))
//     const dispatch = useDispatch();
//     const [filter, setFilter] = useState('');
//     const [field, setField] = useState('');

//     const data = {option: "sync_date", dtValue: "2021-01-14"}
//     useEffect(()=>{
//         if (!marutiFetched)
//             dispatch(fetchMaruti(data));
//     }, [marutiFetched]);
//     const fetchList = (values) => {
//         dispatch(fetchMaruti(values))
//     }
//     const applyFilter = (status)=>{
//         setFilter(status)
//     }

//     const changeComponent = (value)=>{
//         if(value.option == 'trans_ref_num' || value.option == 'trans_id' ){
//             setField('inputField')
//         } else{
//             setField('')
//         }
//     }

//     return (
//         <div>
//                 <Grid >
//                     <Grid.Column floated='left' width={9} >
//                         <Header as='h1'  align='left'>Maruti DMS Transactions - Sync Status</Header>
//                     </Grid.Column>
//                     <Grid.Column floated='right' width={5} style={{textAlign:'right'}} >
//                         <Formik id="commissionSearch"
//                                 onSubmit={(values) => {fetchList(values)}}
//                                 // validationSchema={doReceiptSearchListSchema}
//                                 // initialValues={doReceiptListSearch}
//                                 render={({ handleSubmit, errors, onChange, values, handleChange }) => (
//                                 <Form as={FormikForm} size="small" width={5} onSubmit={handleSubmit}>
//                                     <Form.Group>
//                                         <SyncOptions isLabel={true} onChange={changeComponent(values)}  name="option" placeholder="Sync Option " isTxn={false} isSelection={true}/>
//                                         {field === ''
//                                         ?<Field name="dtValue" isAutoComplete={true}  component={FormikDateComponent} isLabel='false' isTxn='true' placeholder='Sync Date'/>
//                                         :<Field name="txtValue" component={FormikInputComponent} isLabel='false' isTxn='true' placeholder='Sync Date'/>
//                                         }
//                                         <Button type="submit" size="small" color='blue' > Search </Button>
//                                     </Form.Group>
//                                 </Form>
//                                 )}
//                             />
//                     </Grid.Column>
//                 </Grid>
//                 <Grid.Row>
//                     {
//                         summary.status == false ?
//                         <></>:

//                         <>
//                             <Label onClick={() => applyFilter('')} size="large" className={filter === '' ? 'active filter-label all' : 'filter-label all'} >all
//                                 <Label.Detail>{maruti.length}</Label.Detail>
//                             </Label>
//                             { Object.values(summary).map((key) =>
//                                 <Label onClick={() => applyFilter(key.status)} size="large" key={key.id}  className={key.status === filter ? `active ${key.status} ${'filter-label'}` : [key.status, 'filter-label']} >
//                                     {key.status}
//                                     <Label.Detail>{key.count}</Label.Detail>
//                                 </Label>
//                             )}
//                         </>
//                     }

//                 </Grid.Row>
//             <br/>
//             <Table selectable basic='very'>
//                 <TableHeader>
//                     <Table.Row>
//                         <Table.HeaderCell style={{width:'17%'}}>Txn Date</Table.HeaderCell>
//                         <Table.HeaderCell style={{width:'8%'}}>Txn Type</Table.HeaderCell>
//                         <Table.HeaderCell style={{width:'10%'}}>Txn ID</Table.HeaderCell>
//                         <Table.HeaderCell style={{width:'15%'}}>Txn Ref Num</Table.HeaderCell>
//                         <Table.HeaderCell style={{width:'10%'}}>Dealer Code</Table.HeaderCell>
//                         <Table.HeaderCell style={{width:'20%'}}>Message</Table.HeaderCell>
//                         {/* <Table.HeaderCell>RealBooks Voucher Num</Table.HeaderCell> */}
//                         <Table.HeaderCell style={{width:'10%'}}>Status</Table.HeaderCell>
//                     </Table.Row>
//                     {
//                         filter === ''
//                     ?<Table.Row>
//                                 <FilterCell type='text' filterAction={filterItems} col='trans_date'/>
//                                 <FilterCell type='text' filterAction={filterItems} col='txntype'/>
//                                 <FilterCell type='text' filterAction={filterItems} col='trans_id'/>
//                                 <FilterCell type='text' filterAction={filterItems} col='trans_ref_num'/>
//                                 <FilterCell type='text' filterAction={filterItems} col='mul_dealer_cd'/>
//                                 {/* <FilterCell type='text' filterAction={filterItems} col='rlb_payload.msg'/> */}
//                                 <Table.Cell></Table.Cell>
//                                 <Table.Cell></Table.Cell>
//                         </Table.Row>
//                     :<></>
//                     }
//                 </TableHeader>
//                 <TableBody>

//                     {
//                         filter === '' && filter != "q"?
//                         Object.keys(maruti).map((key, index) =>
//                         <Maruti maruti={marutiById[maruti[key].redisId]} key={maruti[key].redisId} index={index}/> )

//                         :
//                         Object.keys(summary).map((key, index) =>
//                             summary[key].status == filter ?
//                                 Object.keys(summary[key].data).map((k) =>
//                                 <Maruti maruti={marutiById[summary[key].data[k].redisId]} key={summary[key].data[k].redisId} index={index}/> )
//                         :
//                         <></>
//                     )}
//                 </TableBody>
//             </Table>
//         </div>
//     )
// }
// // }

// export default MarutiList;

const MarutiSyncList = (props) => {
    const allData = useSelector((state) => select.getFilteredMarutiList(state));
    const successData = useSelector((state) =>
        select.getFilteredMarutiSuccessList(state)
    );
    const inProcessData = useSelector((state) =>
        select.getFilteredMarutiInProcessList(state)
    );
    const errorData = useSelector((state) =>
        select.getFilteredMarutiErrorList(state)
    );
    const exceptionData = useSelector((state) =>
        select.getFilteredMarutiExceptionList(state)
    );
    const marutiById = useSelector((state) => state.txnsync.byId);
    const marutiFetched = useSelector((state) =>
        select.getIsMarutiFetched(state, props)
    );
    const summary = useSelector((state) => select.getSummary(state));
    const [repostId, setRepostId] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [filter, setFilter] = useState("");
    const [field, setField] = useState("");

    const [allCount, setAllCount] = useState(allData ? allData.length : 0);
    const [errorCount, setErrorCount] = useState(
        errorData ? errorData.length : 0
    );
    const [successCount, setSuccessCount] = useState(
        successData ? successData.length : 0
    );
    const [inProcessCount, setInProcessCount] = useState(
        inProcessData ? inProcessData.length : 0
    );
    const [exceptionCount, setExceptionCount] = useState(
        exceptionData ? exceptionData.length : 0
    );
    const [allDataBtn, setAllDataBtn] = useState(false);
    const [successDataBtn, setSuccessDataBtn] = useState(false);
    const [inProcessDataBtn, setInProcessDataBtn] = useState(false);
    const [errorDataBtn, setErrorDataBtn] = useState(false);
    const [exceptionDataBtn, setExceptionDataBtn] = useState(false);
    const [modalUtd, setModalUtd] = useState(false);

    const [heights, setHeight] = useState("");
    const [getBodyHeight, setGetBodyHeight] = useState("");

    const notificationPopup = useSelector((state) =>
        select.getNotificationPopup(state, props)
    );


    const dispatch = useDispatch();
    const data = { option: "sync_date", dtValue: "2021-01-14" };

    useEffect(() => {
        let notify = notificationPopup.type;
        if (notify) {
            let status =
                notify.status && notify.status !== undefined && notify.status !== null
                    ? notify.status
                    : "",
                msg =
                    notify.msg && notify.msg !== undefined && notify.msg !== null
                        ? notify.msg
                        : notify.msg,
                options = {};
            if (status !== "") {
                if (count === 0) {
                    if (status === "success") {
                        options = {
                            className: "toast-position",
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: true,
                        };
                        toast["success"](msg, options);
                    } else {
                        options = {
                            className: "toast-position",
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: true,
                        };
                        toast["error"](msg, options);
                    }
                    setTimeout(function () {
                        dispatch(setNotifyDone());
                        count = 0;
                    }, 500);
                    count++;
                }
            }
        }
    }, [notificationPopup]);

    useEffect(() => {
        if (!marutiFetched) dispatch(fetchMaruti(data));
        setAllDataBtn(true);
        setSuccessDataBtn(false);
        setErrorDataBtn(false);
        setExceptionDataBtn(false);
        setInProcessDataBtn(false);
    }, [marutiFetched]);

    const fetchList = (values) => {
        dispatch(fetchMaruti(values));
        setAllDataBtn(true);
        setSuccessDataBtn(false);
        setErrorDataBtn(false);
        setExceptionDataBtn(false);
        setInProcessDataBtn(false);
    };

    const callHeightFunc = () => {
        heightSet(setHeight);
        rowBodyHeightSet(setGetBodyHeight);
    };

    const showDetails = (syncObj) => {
        setErrorMsg(syncObj);
        setTimeout(() => {
            setModalOpen(true);
        }, 200);
    };

    const reposting = (redisId) => {
        dispatch(repost(redisId));
    };

    const syncAction = ({ object: syncObj }) => {
        // console.log(syncObj, '-----')
        return (
            <>
                {syncObj.type === "error" || syncObj.type === "exception" ? (
                    <Table.Cell>
                        <span
                            style={{
                                textTransform: "capitalize",
                                color: "red",
                                cursor: "pointer",
                            }}
                            onClick={() => showDetails(syncObj)}
                        >
                            {syncObj.type}
                        </span>
                        {/* &nbsp;&nbsp;&nbsp;&nbsp; */}
                        {/* {syncObj["postStatus"] === undefined ? (
                            <span
                                style={{ color: "blue", cursor: "pointer" }}
                                onClick={() => reposting(syncObj.redisId)}
                            >
                                Repost
                            </span>
                        ) : (
                            <span style={{ color: "green" }}>Reposted</span>
                        )} */}
                    </Table.Cell>
                ) : (
                    <Table.Cell
                        style={{
                            color: "green",
                            textTransform: "capitalize",
                            cursor: "pointer",
                            marginRight: "20px",
                        }}
                        onClick={() => showDetails(syncObj)}
                    >
                        {syncObj.type}
                    </Table.Cell>
                )}
            </>
        );
    };

    const changeComponent = (value) => {
        if (value.option == "trans_ref_num" || value.option == "trans_id") {
            setField("inputField");
        } else {
            setField("");
        }
    };

    const syncUtdNum = (value) => {
        if (value.utd) {
            dispatch(syncUtd(value))
            setModalUtd(false)
        }
    }

    const showAllList = () => {
        setAllDataBtn(true);
        setSuccessDataBtn(false);
        setErrorDataBtn(false);
        setExceptionDataBtn(false);
        setInProcessDataBtn(false);
    };

    const showSuccessList = () => {
        setSuccessDataBtn(true);
        setAllDataBtn(false);
        setErrorDataBtn(false);
        setExceptionDataBtn(false);
        setInProcessDataBtn(false);
    };
    const showInProcessList = () => {
        setInProcessDataBtn(true);
        setErrorDataBtn(false);
        setSuccessDataBtn(false);
        setAllDataBtn(false);
        setExceptionDataBtn(false);
    };
    const showErrorList = () => {
        setErrorDataBtn(true);
        setSuccessDataBtn(false);
        setAllDataBtn(false);
        setExceptionDataBtn(false);
        setInProcessDataBtn(false);
    };
    const showExceptionList = () => {
        setExceptionDataBtn(true);
        setSuccessDataBtn(false);
        setAllDataBtn(false);
        setErrorDataBtn(false);
        setInProcessDataBtn(false);
    };

    return (
        <>
            <Grid>
                <Grid.Column floated="left" width={8}>
                    <Header as="h1" align="left">
                        Maruti DMS TO Vehicle Booking - Sync Status
                    </Header>
                </Grid.Column>
                <Grid.Column floated="right" width={8}>
                    <Formik
                        id="commissionSearch"
                        onSubmit={(values) => {
                            fetchList(values);
                        }}
                        // validationSchema={doReceiptSearchListSchema}
                        // initialValues={doReceiptListSearch}
                        render={({
                            handleSubmit,
                            errors,
                            onChange,
                            values,
                            handleChange,
                        }) => (
                            <Form
                                as={FormikForm}
                                size="small"
                                width={5}
                                onSubmit={handleSubmit}
                            >
                                <Form.Group>
                                    <SyncOptions
                                        isLabel={true}
                                        onChange={changeComponent(values)}
                                        name="option"
                                        placeholder="Sync Option "
                                        isTxn={false}
                                        isSelection={true}
                                    />
                                    {field === "" ? (
                                        <Field
                                            name="dtValue"
                                            isAutoComplete={true}
                                            component={FormikDateComponent}
                                            isLabel="false"
                                            isTxn="true"
                                            placeholder="Sync Date"
                                        />
                                    ) : (
                                        <Field
                                            name="txtValue"
                                            component={FormikInputComponent}
                                            isLabel="false"
                                            isTxn="true"
                                            placeholder="Sync Date"
                                        />
                                    )}
                                    <Button type="submit" size="tini" color="blue">
                                        {" "}
                                        Search{" "}
                                    </Button>
                                    {/* <Button
                                        type="button"
                                        size="small"
                                        color="blue"
                                        onClick={() => {
                                            setModalUtd(true);
                                        }}
                                    >
                                        Post Missing UTD{" "}
                                    </Button> */}
                                </Form.Group>
                            </Form>
                        )}
                    />
                </Grid.Column>
            </Grid>
            <Grid>
                <Grid.Row>
                    <Grid.Column width={9}>
                        {allDataBtn ? (
                            <Label
                                onClick={() => showAllList()}
                                size="large"
                                className="allLabel"
                                style={{
                                    background: "#556aed",
                                    marginRight: "10px",
                                    color: "white",
                                }}
                            >
                                All
                                <Label.Detail style={{ color: "white" }}>
                                    {allCount}
                                </Label.Detail>
                            </Label>
                        ) : (
                            <Label
                                onClick={() => showAllList()}
                                size="large"
                                className="allLabel"
                                style={{ background: "", marginRight: "10px" }}
                            >
                                All
                                <Label.Detail>{allData.length}</Label.Detail>
                            </Label>
                        )}
                        {successDataBtn ? (
                            <Label
                                onClick={() => showSuccessList()}
                                size="large"
                                className="successLabel"
                                style={{ background: "#31eb59", marginRight: "10px" }}
                            >
                                Success
                                <Label.Detail>{successCount}</Label.Detail>
                            </Label>
                        ) : (
                            <Label
                                onClick={() => showSuccessList()}
                                size="large"
                                className="successLabel"
                                style={{ background: "", marginRight: "10px" }}
                            >
                                Success
                                <Label.Detail>{successData.length}</Label.Detail>
                            </Label>
                        )}
                        {/* {inProcessDataBtn ? (
                            <Label
                                onClick={() => showInProcessList()}
                                size="large"
                                className="successLabel"
                                style={{ background: "#ff8000", marginRight: "10px" }}
                            >
                                In-Process
                                <Label.Detail>{inProcessCount}</Label.Detail>
                            </Label>
                        ) : (
                            <Label
                                onClick={() => showInProcessList()}
                                size="large"
                                className="successLabel"
                                style={{ background: "", marginRight: "10px" }}
                            >
                                In-Process
                                <Label.Detail>{inProcessData.length}</Label.Detail>
                            </Label>
                        )} */}
                        {errorDataBtn ? (
                            <Label
                                onClick={() => showErrorList()}
                                size="large"
                                className="errorLabel"
                                style={{
                                    background: "#ed454a",
                                    marginRight: "10px",
                                    color: "white",
                                }}
                            >
                                Error
                                <Label.Detail style={{ color: "white" }}>
                                    {errorCount}
                                </Label.Detail>
                            </Label>
                        ) : (
                            <Label
                                onClick={() => showErrorList()}
                                size="large"
                                className="errorLabel"
                                style={{ background: "", marginRight: "10px" }}
                            >
                                Error
                                <Label.Detail>{errorData.length}</Label.Detail>
                            </Label>
                        )}
                        {exceptionDataBtn ? (
                            <Label
                                onClick={() => showExceptionList()}
                                size="large"
                                className="exceptionLabel"
                                style={{
                                    background: "#b300b3",
                                    marginRight: "10px",
                                    color: "white",
                                }}
                            >
                                Exception
                                <Label.Detail>{exceptionCount}</Label.Detail>
                            </Label>
                        ) : (
                            <Label
                                onClick={() => showExceptionList()}
                                size="large"
                                className="exceptionLabel"
                                style={{ background: "", marginRight: "10px" }}
                            >
                                Exception
                                <Label.Detail>{exceptionData.length}</Label.Detail>
                            </Label>
                        )}
                    </Grid.Column>
                </Grid.Row>
            </Grid>

            {marutiFetched === false ? (
                <div style={{ height: "80vh", weight: "100%" }}>Loading...</div>
            ) : (
                <>
                    {allDataBtn ? (
                        <div className="" style={{ paddingTop: "10px" }}>
                            <TableListDiv
                                columns={searchColumns}
                                data={allData}
                                Actions={syncAction}
                                setAllCount={setAllCount}
                                setHeight={parseFloat(heights) - 80}
                                getIndex={9}
                                filterBoxNone={""}
                                rightBox={""}
                                centerBox={""}
                                callHeightFunc={callHeightFunc}
                                paddingShort={2}
                                getWidth={"100%"}
                                actionClass={"actionTdDR"}
                            />
                        </div>
                    ) : null}
                </>
            )}

            {marutiFetched === false ? (
                <div style={{ height: "80vh", weight: "100%" }}>Loading...</div>
            ) : (
                <>
                    {successDataBtn ? (
                        <div className="" style={{ paddingTop: "10px" }}>
                            <TableListDiv
                                columns={searchColumns}
                                data={successData}
                                Actions={syncAction}
                                setSuccessCount={setSuccessCount}
                                setHeight={parseFloat(heights) - 80}
                                getIndex={9}
                                filterBoxNone={""}
                                rightBox={""}
                                centerBox={""}
                                callHeightFunc={callHeightFunc}
                                paddingShort={2}
                                getWidth={"100%"}
                                actionClass={"actionTdDR"}
                            />
                        </div>
                    ) : null}
                </>
            )}

            {marutiFetched === false ? (
                <div style={{ height: "80vh", weight: "100%" }}>Loading...</div>
            ) : (
                <>
                    {inProcessDataBtn ? (
                        <div className="" style={{ paddingTop: "10px" }}>
                            <TableListDiv
                                columns={searchColumns}
                                data={inProcessData}
                                Actions={syncAction}
                                setInProcessCount={setInProcessCount}
                                setHeight={parseFloat(heights) - 80}
                                getIndex={9}
                                filterBoxNone={""}
                                rightBox={""}
                                centerBox={""}
                                callHeightFunc={callHeightFunc}
                                paddingShort={2}
                                getWidth={"100%"}
                                actionClass={"actionTdDR"}
                            />
                        </div>
                    ) : null}
                </>
            )}

            {marutiFetched === false ? (
                <div style={{ height: "80vh", weight: "100%" }}>Loading...</div>
            ) : (
                <>
                    {errorDataBtn ? (
                        <div className="" style={{ paddingTop: "10px" }}>
                            <TableListDiv
                                columns={searchColumns}
                                data={errorData}
                                Actions={syncAction}
                                setErrorCount={setErrorCount}
                                setHeight={parseFloat(heights) - 80}
                                getIndex={9}
                                filterBoxNone={""}
                                rightBox={""}
                                centerBox={""}
                                callHeightFunc={callHeightFunc}
                                paddingShort={2}
                                getWidth={"100%"}
                                actionClass={"actionTdDR"}
                            />
                        </div>
                    ) : null}
                </>
            )}

            {marutiFetched === false ? (
                <div style={{ height: "80vh", weight: "100%" }}>Loading...</div>
            ) : (
                <>
                    {exceptionDataBtn ? (
                        <div className="" style={{ paddingTop: "10px" }}>
                            <TableListDiv
                                columns={searchColumns}
                                data={exceptionData}
                                Actions={syncAction}
                                setExceptionCount={setExceptionCount}
                                setHeight={parseFloat(heights) - 80}
                                getIndex={9}
                                filterBoxNone={""}
                                rightBox={""}
                                centerBox={""}
                                callHeightFunc={callHeightFunc}
                                paddingShort={2}
                                getWidth={"100%"}
                                actionClass={"actionTdDR"}
                            />
                        </div>
                    ) : null}
                </>
            )}
            <Modal open={modalUtd} size="mini">
                {/* <Modal.Header>
        <Grid >
            <Grid.Row>
                <Grid.Column floated="right" width={3}>
                <Button
              size="small"
              color="red"
              icon="cancel"
            >
              
            </Button>
                </Grid.Column>
            </Grid.Row>
        </Grid>
      </Modal.Header> */}
                <Modal.Content>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column floated="right" width={3}>
                                <Button
                                    size="small"
                                    color="red"
                                    icon="cancel"
                                    onClick={() => {
                                        setModalUtd(false);
                                    }}
                                ></Button>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    <Formik
                        id="itemForm"
                        size="large"
                        width={5}
                        initialValues={missingUtd()}
                        validationSchema={missingUtdSchema}
                        onSubmit={(values, { resetForm }) => syncUtdNum(values, resetForm)}
                        render={({ handleSubmit, onChange, values, handleChange }) => (
                            <Form
                                as={FormikForm}
                                size="small"
                                // className="CustomeForm"
                                width={5}
                                onSubmit={handleSubmit}
                            >
                                <Form.Group>
                                    <Field
                                        name="utd"
                                        label="Post Missing UTD"
                                        component={FormikIntegerComponent}
                                        isMandatory={true}
                                    ></Field>
                                </Form.Group>
                                <center>
                                    <Button
                                        type="submit"
                                        size="small"
                                        color="blue"
                                        style={{ width: "35%" }}
                                    >
                                        Sync
                                    </Button>
                                </center>
                            </Form>
                        )}
                    />
                </Modal.Content>
            </Modal>
            <Modal open={isModalOpen} size="small">
                <Modal.Header>
                    {" "}
                    {errorMsg.type === ("exception" || "Exception")
                        ? "Exception Msg"
                        : errorMsg.type === ("error" || "Error")
                            ? "Error Msg"
                            : "Success Msg"}
                </Modal.Header>
                <Modal.Content>
                    <h4>redisId :&nbsp; {errorMsg ? errorMsg.redisId : ""}</h4>
                    <h4>{errorMsg ? errorMsg.msg : ""}</h4>
                </Modal.Content>
                <Modal.Actions>
                    <Button type="button" positive onClick={() => setModalOpen(false)}>
                        Ok
                    </Button>
                </Modal.Actions>
            </Modal>
        </>
    );
};

export default MarutiSyncList;
